import { setTerms } from './helpers';

export const setBuilders = setTerms('builders_ids');
